import { render, staticRenderFns } from "./rating.vue?vue&type=template&id=0181ccd5&scoped=true&"
var script = {}
import style0 from "./rating.vue?vue&type=style&index=0&id=0181ccd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0181ccd5",
  null
  
)

export default component.exports